import axios from "@util/axios";
import projectConfig from "@projectConfig";

const { hostCloud } = projectConfig.api;

export const addPreset = async (widgetId, preset) => {
   return axios({
      method: "POST",
      url: `${hostCloud}/filters`,
      headers: {
         Accept: "*/*"
      },
      params: { widgetId },
      data: [preset]
   });
};

export const updatePreset = async (widgetId, preset) => {
   return axios({
      method: "PUT",
      url: `${hostCloud}/filters`,
      headers: {
         Accept: "*/*"
      },
      params: { widgetId },
      data: [preset]
   });
};

export const deletePreset = async (widgetId, presetId) => {
   return axios({
      method: "DELETE",
      url: `${hostCloud}/filters`,
      headers: {
         Accept: "*/*"
      },
      params: { widgetId },
      data: [presetId]
   });
};
